module.exports = __webpack_public_path__ + "img/dialog-exchange.1d005ba7.svg";